import React from "react";
import { useNavigate } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import { IconButton } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import DashboardContentMobile from "./DashboardContentMobile";
import RehappPromptsContent from "./RehappPromptsContent";
import NavbarV2 from "../component/NavbarV2";

export default function RehappPrompts() {
  const navigate = useNavigate();

  const handleMenuOpen = () => {
    navigate("/menumobile");
  };

  const isMobile = useMediaQuery({ query: "(max-width: 800px)" });
  return (
    <div className="main-container">
      {isMobile ? (
        <>
          <div className="menu-button-container">
            <IconButton
              edge="start"
              color="inherit"
              aria-label="menu"
              onClick={handleMenuOpen}
              className="menu-button"
            >
              <MenuIcon />
            </IconButton>
          </div>

          <DashboardContentMobile />
        </>
      ) : (
        <>
          <NavbarV2 linkActive={4} />
          <RehappPromptsContent />
        </>
      )}
    </div>
  );
}
